import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PaymentDetail(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cashier, setCashier] = useState({ username: '' });
  const [mode, setMode] = useState({ mode: '' });

  const [userData, setUserData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [refundData, setRefundData] = useState([]);
  const [dueData, setdueData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setCashier({
        ...cashier,
        username: event.target.value
      });
    };
    const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);



  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
    const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}all-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=${cashier.username}&mode=${mode.mode}&status=2`;

    try {
      const response = await axios.get(url);
      const data = response.data;

      const formattedData = await Promise.all(data.map(async item => {
        const minidArray = item.min_id ? item.min_id.split(',') : [];
        const itestidArray = item.itest_id ? item.itest_id.split(',') : [];

        const minidRequests = minidArray.map(id => axios.get(`${baseUrl}edit-minor-comp/${id}`));
        const itestidRequests = itestidArray.map(id => axios.get(`${baseUrl}edit-components/${id}`));

        const [minidResponses, itestidResponses] = await Promise.all([
          Promise.all(minidRequests),
          Promise.all(itestidRequests)
        ]);

        const minData = minidResponses.map(response => response.data.cat.cat);
        const invData = itestidResponses.map(response => response.data.cat);

        let audiology = 0;
        let dental = 0;
        let dialysis = 0;
        let minor = 0;
        let ct = 0;
        let xray = 0;
        let scan = 0;
        let audiologyt = 0;
        let dentalt = 0;
        let dialysist = 0;
        let minort = 0;
        let ctt = 0;
        let xrayt = 0;
        let scant = 0;
        let audiologyb = 0;
        let dentalb = 0;
        let dialysisb = 0;
        let minorb = 0;
        let ctb = 0;
        let xrayb = 0;
        let scanb = 0;

        if (minData.includes('Audiology')) {
          audiology = item.min_paid || 0;
          audiologyt = item.min_tot || 0;
          audiologyb = item.min_balance || 0;
        } else if (minData.includes('Dental')) {
          dental = item.min_paid || 0;
          dentalt = item.min_tot || 0;
          dentalb = item.min_balance || 0;
        } else if (minData.includes('Dialysis')) {
          dialysis = item.min_paid || 0;
          dialysist = item.min_tot || 0;
          dialysisb = item.min_balance || 0;
        } else {
          minor = item.min_paid || 0;
          minort = item.min_tot || 0;
          minorb = item.min_balance || 0;
        }

        if (invData.includes('CT')) {
          ct = item.inv_paid || 0;
          ctt = item.inv_tot || 0;
          ctb = item.inv_balance || 0;
        } else if (invData.includes('Xray')) {
          xray = item.inv_paid || 0;
          xrayt = item.inv_tot || 0;
          xrayb = item.inv_balance || 0;
        } else if (invData.includes('USG')) {
          scan = item.inv_paid || 0;
          scant = item.inv_tot || 0;
          scanb = item.inv_balance || 0;
        }

        let invoiceLink = '';
        if (item.invoice) {
          invoiceLink = `/op-invoice/${item.invoice}`;
        } else if (item.lab_invoice) {
          invoiceLink = `/lab-invoice-op/${item.lab_invoice}`;
        } else if (item.inv_invoice) {
          invoiceLink = `/inv-invoice-op/${item.inv_invoice}`;
        } else if (item.min_invoice) {
          invoiceLink = `/min-invoice-op/${item.min_invoice}`;
        }

        return {
          ...item,
          fee: item.paid || 0,
          lab: item.lab_paid || 0,
          fee1: item.fee || 0,
          labt: item.lab_tot || 0,
          feeb: item.balance || 0,
          labb: item.lab_balance || 0,
          ct,
          xray,
          scan,
          dialysis,
          audiology,
          dental,
          minor,
          ctt,
          xrayt,
          scant,
          dialysist,
          audiologyt,
          dentalt,
          minort,
          ctb,
          xrayb,
          scanb,
          dialysisb,
          audiologyb,
          dentalb,
          minorb,
          mode: item.mode || item.lab_pmode || item.inv_pmode || item.min_pmode || '',
          invoice: item.invoice || item.lab_invoice || item.inv_invoice || item.min_invoice || '',
          invoiceLink,
          minData,
          invData
        };
      }));

      setCombinedData(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [startDate, endDate, cashier.username, mode.mode]);
useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
      fetchrefData();
      fetchdueData();
  }, [startDate, endDate]);

  function fetchrefData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setRefundData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
  function fetchdueData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}due-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setdueData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }

const columnsInvoiced = [
    { field: 'add_date_date', headerName: 'Date', width: 100 },
    { field: 'appt_id', headerName: 'Appointment ID', width: 120 },
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 80 },
    { field: 'pat__patient', headerName: 'Patient Name', width: 150 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 200 },
    {
      field: 'invoice',
      headerName: 'Invoice No',
      renderCell: (params) => (
        <Link to={params.row.invoiceLink} target="_blank">
          {params.row.invoice}
        </Link>
      ),
      width: 140
    },
    { field: 'fee1', headerName: 'Consulting', width: 80 },
    { field: 'labt', headerName: 'Lab', width: 80 },
    { field: 'ctt', headerName: 'CT', width: 80 },
    { field: 'xrayt', headerName: 'Xray', width: 80 },
    { field: 'scant', headerName: 'Scan', width: 80 },
    { field: 'dialysist', headerName: 'Dialysis', width: 80 },
    { field: 'audiologyt', headerName: 'audiology', width: 80 },
    { field: 'dentalt', headerName: 'Dental', width: 80 },
    { field: 'minort', headerName: 'Minor', width: 80 },
    { field: 'mode', headerName: 'Mode', width: 80 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];
  const columnsDue = [
    { field: 'add_date_date', headerName: 'Date', width: 100 },
    { field: 'appt_id', headerName: 'Appointment ID', width: 120 },
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 80 },
    { field: 'pat__patient', headerName: 'Patient Name', width: 150 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 200 },
    {
      field: 'invoice',
      headerName: 'Invoice No',
      renderCell: (params) => (
        <Link to={params.row.invoiceLink} target="_blank">
          {params.row.invoice}
        </Link>
      ),
      width: 140
    },
    { field: 'feeb', headerName: 'Consulting', width: 80 },
    { field: 'labb', headerName: 'Lab', width: 80 },
    { field: 'ctb', headerName: 'CT', width: 80 },
    { field: 'xrayb', headerName: 'Xray', width: 80 },
    { field: 'scanb', headerName: 'Scan', width: 80 },
    { field: 'dialysisb', headerName: 'Dialysis', width: 80 },
    { field: 'audiologyb', headerName: 'audiology', width: 80 },
    { field: 'dentalb', headerName: 'Dental', width: 80 },
    { field: 'minorb', headerName: 'Minor', width: 80 },
    { field: 'mode', headerName: 'Mode', width: 80 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];
const columnsCollect = [
    { field: 'add_date_date', headerName: 'Date', width: 100 },
    { field: 'appt_id', headerName: 'Appointment ID', width: 120 },
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 80 },
    { field: 'pat__patient', headerName: 'Patient Name', width: 150 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 200 },
    {
      field: 'invoice',
      headerName: 'Invoice No',
      renderCell: (params) => (
        <Link to={params.row.invoiceLink} target="_blank">
          {params.row.invoice}
        </Link>
      ),
      width: 140
    },
    { field: 'fee', headerName: 'Consulting', width: 80 },
    { field: 'lab', headerName: 'Lab', width: 80 },
    { field: 'ct', headerName: 'CT', width: 80 },
    { field: 'xray', headerName: 'Xray', width: 80 },
    { field: 'scan', headerName: 'Scan', width: 80 },
    { field: 'dialysis', headerName: 'Dialysis', width: 80 },
    { field: 'audiology', headerName: 'audiology', width: 80 },
    { field: 'dental', headerName: 'Dental', width: 80 },
    { field: 'minor', headerName: 'Minor', width: 80 },
    { field: 'mode', headerName: 'Mode', width: 80 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];

  // Function to get row id for DataGrid
  const getRowId = (row) => row.appt_id;

const calculateTotal = (rows, field) => {
  return rows.reduce((total, row) => total + Number(row[field]) || 0, 0);
};

// Custom Footer component for "Invoiced Report" table
  const FooterInvoiced = ({ rows }) => {
  let totalFee1 = 0;
  let totalLabt = 0;
  let totalCtt = 0;
  let totalXrayt = 0;
  let totalScant = 0;
  let totalDialysist = 0;
  let totalaudiologyt = 0;
  let totalDentalt = 0;
  let totalMinort = 0;

  rows.forEach((row) => {
    totalFee1 += Number(row.fee1) || 0;
    totalLabt += Number(row.labt) || 0;
    totalCtt += Number(row.ctt) || 0;
    totalXrayt += Number(row.xrayt) || 0;
    totalScant += Number(row.scant) || 0;
    totalDialysist += Number(row.dialysist) || 0;
    totalaudiologyt += Number(row.audiologyt) || 0;
    totalDentalt += Number(row.dentalt) || 0;
    totalMinort += Number(row.minort) || 0;
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total Consulting: {totalFee1}</div>
      <div>Total Lab: {totalLabt}</div>
      <div>Total CT: {totalCtt}</div>
      <div>Total Xray: {totalXrayt}</div>
      <div>Total Scan: {totalScant}</div>
      <div>Total Dialysis: {totalDialysist}</div>
      <div>Total audiology: {totalaudiologyt}</div>
      <div>Total Dental: {totalDentalt}</div>
      <div>Total Minor: {totalMinort}</div>
    </div>
  );
};
const FooterCollect = ({ rows }) => {
  let totalFee = 0;
  let totalLab = 0;
  let totalCt = 0;
  let totalXray = 0;
  let totalScan = 0;
  let totalDialysis = 0;
  let totalaudiology = 0;
  let totalDental = 0;
  let totalMinor = 0;

  rows.forEach((row) => {
    totalFee += Number(row.fee) || 0;
    totalLab += Number(row.lab) || 0;
    totalCt += Number(row.ct) || 0;
    totalXray += Number(row.xray) || 0;
    totalScan += Number(row.scan) || 0;
    totalDialysis += Number(row.dialysis) || 0;
    totalaudiology += Number(row.audiology) || 0;
    totalDental += Number(row.dental) || 0;
    totalMinor += Number(row.minor) || 0;
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total Consulting: {totalFee}</div>
      <div>Total Lab: {totalLab}</div>
      <div>Total CT: {totalCt}</div>
      <div>Total Xray: {totalXray}</div>
      <div>Total Scan: {totalScan}</div>
      <div>Total Dialysis: {totalDialysis}</div>
      <div>Total audiology: {totalaudiology}</div>
      <div>Total Dental: {totalDental}</div>
      <div>Total Minor: {totalMinor}</div>
    </div>
  );
};
const FooterDue = ({ rows }) => {
  let totalFeeb = 0;
  let totalLabb = 0;
  let totalCtb = 0;
  let totalXrayb = 0;
  let totalScanb = 0;
  let totalDialysisb = 0;
  let totalaudiologyb = 0;
  let totalDentalb = 0;
  let totalMinorb = 0;

  rows.forEach((row) => {
    totalFeeb += Number(row.feeb) || 0;
    totalLabb += Number(row.labb) || 0;
    totalCtb += Number(row.ctb) || 0;
    totalXrayb += Number(row.xrayb) || 0;
    totalScanb += Number(row.scanb) || 0;
    totalDialysisb += Number(row.dialysisb) || 0;
    totalaudiologyb += Number(row.audiologyb) || 0;
    totalDentalb += Number(row.dentalb) || 0;
    totalMinorb += Number(row.minorb) || 0;
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total Consulting: {totalFeeb}</div>
      <div>Total Lab: {totalLabb}</div>
      <div>Total CT: {totalCtb}</div>
      <div>Total Xray: {totalXrayb}</div>
      <div>Total Scan: {totalScanb}</div>
      <div>Total Dialysis: {totalDialysisb}</div>
      <div>Total audiology: {totalaudiologyb}</div>
      <div>Total Dental: {totalDentalb}</div>
      <div>Total Minor: {totalMinorb}</div>
    </div>
  );
};

  const today = new Date();

    const rows1 = refundData.map((item1) => {
    return {
      id: item1.id,
      date_time: `${item1.add_date_date} ${item1.add_time}`,
      pat__pat_id: item1.pat__pat_id,
      pat__patient: item1.pat__patient,
      invoice: item1.invoice,
      receipt: item1.receipt,
      invoice_amount: item1.invoice_amount,
      paid_amount: item1.paid_amount,
      refund_amount: item1.refund_amount,
      balance: item1.balance,
      receivedby: item1.receivedby,
      reason: item1.reason,
      addedby: item1.addedby,
    };
    });

  const columns1 = [
    { field: 'date_time', headerName: 'Date', width: 150 },
    { field: 'pat__pat_id', headerName: 'Pat ID', width: 50},
    { field: 'pat__patient', headerName: 'Patient', width: 150 },
    { field: 'invoice', headerName: 'Invoice', width: 110 },
    { field: 'receipt', headerName: 'Refund Receipt',
        renderCell: (params) => (
          <Link to={`/refund-invoice-op/${params.row.receipt}`} target="_blank">
            {params.row.receipt}
          </Link>
      ),
      width: 120 },
    { field: 'invoice_amount', headerName: 'Invoiced Amount', width: 100 },
    { field: 'paid_amount', headerName: 'Paid Amount', width: 100 },
    { field: 'refund_amount', headerName: 'Refund Amount', width: 100 },
    { field: 'balance', headerName: 'Balance', width: 100 },
    { field: 'receivedby', headerName: 'Received By', width: 100 },
    { field: 'reason', headerName: 'Reason', width: 100 },
    { field: 'addedby', headerName: 'Updated By', width: 100 },
  ];

  const getTotal1 = (rows1, field) => {
    return rows1.reduce((total1, row1) => total1 + parseFloat(row1[field]), 0);
  };

   const Footer1 = ({ rows1 }) => {
      const totalInvoicedAmount1 = getTotal1(rows1, 'invoice_amount');
      const totalPaidAmount1 = getTotal1(rows1, 'paid_amount');
      const totalBalance1 = getTotal1(rows1, 'balance');
      const totalRefundAmount1 = getTotal1(rows1, 'refund_amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalInvoicedAmount1}</div>
          <div>{totalPaidAmount1}</div>
          <div>{totalRefundAmount1}</div>
          <div>{totalBalance1}</div>
        </div>
      );
    };
    const rows2 = dueData.map((item) => {
    return {
      id: item.id,
      date_time: `${item.add_date_date} ${item.add_time}`,
      pat__pat_id: item.pat__pat_id,
      pat__patient: item.pat__patient,
      invoice: item.invoice,
      receipt: item.receipt,
      invoice_amount: item.invoice_amount,
      paid_amount: item.paid_amount,
      due_amount: item.due_amount,
      balance: item.balance,
      receivedby: item.receivedby,
      reason: item.reason,
      addedby: item.addedby,
    };
    });

  const columns2 = [
    { field: 'date_time', headerName: 'Date', width: 150 },
    { field: 'pat__pat_id', headerName: 'Pat ID', width: 50},
    { field: 'pat__patient', headerName: 'Patient', width: 150 },
    { field: 'invoice', headerName: 'Invoice', width: 110 },
    { field: 'receipt', headerName: 'Due Receipt',
        renderCell: (params) => (
          <Link to={`/due-invoice-op/${params.row.receipt}`} target="_blank">
            {params.row.receipt}
          </Link>
      ),
      width: 120 },
    { field: 'invoice_amount', headerName: 'Invoiced Amount', width: 100 },
    { field: 'paid_amount', headerName: 'Paid Amount', width: 100 },
    { field: 'due_amount', headerName: 'Due Amount', width: 100 },
    { field: 'balance', headerName: 'Balance', width: 100 },
    { field: 'receivedby', headerName: 'Received By', width: 100 },
    { field: 'reason', headerName: 'Reason', width: 100 },
    { field: 'addedby', headerName: 'Updated By', width: 100 },
  ];

  const getTotal2 = (rows, field) => {
    return rows2.reduce((total2, row2) => total2 + parseFloat(row2[field]), 0);
  };

   const Footer2 = ({ rows2 }) => {
      const totalInvoicedAmount2 = getTotal2(rows2, 'invoice_amount');
      const totalPaidAmount2 = getTotal2(rows2, 'paid_amount');
      const totalBalance2 = getTotal2(rows2, 'balance');
      const totaldueAmount2 = getTotal2(rows2, 'due_amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalInvoicedAmount2}</div>
          <div>{totalPaidAmount2}</div>
          <div>{totaldueAmount2}</div>
          <div>{totalBalance2}</div>
        </div>
      );
    };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Payment Detail Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            </div>
            </div>
            <div className="col-md-6">
            <div className="mb-4 mt-4">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={cashier.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Sales Mode</option>
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="creditpay">Credit Payment</option>
                <option value="UPI">UPI</option>
              </select>
            </div>
            </div>
           </div>
    <div>
     <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
      <button className="nav-link active border-success" id="nav-invoiced-tab" data-bs-toggle="tab"
            data-bs-target="#nav-invoiced" type="button" role="tab" aria-controls="nav-invoiced"
            aria-selected="true">Invoiced</button>
     <button className="nav-link  border-primary " id="nav-collected-tab" data-bs-toggle="tab"
        data-bs-target="#nav-collected" type="button" role="tab" aria-controls="nav-collected"
        aria-selected="false">Collected</button>
        <button className="nav-link  border-primary " id="nav-refund-tab" data-bs-toggle="tab"
            data-bs-target="#nav-refund" type="button" role="tab" aria-controls="nav-refund"
            aria-selected="false">Refund</button>
        <button className="nav-link  border-primary " id="nav-due-tab" data-bs-toggle="tab"
        data-bs-target="#nav-due" type="button" role="tab" aria-controls="nav-due"
        aria-selected="false">Paid Dues</button>
        <button className="nav-link  border-primary " id="nav-discount-tab" data-bs-toggle="tab"
        data-bs-target="#nav-discount" type="button" role="tab" aria-controls="nav-discount"
        aria-selected="false">Discount</button>
        <button className="nav-link  border-primary " id="nav-pending-tab" data-bs-toggle="tab"
        data-bs-target="#nav-pending" type="button" role="tab" aria-controls="nav-pending"
        aria-selected="false">Pending Dues</button>
      </div>
    </nav>
  <div className="tab-content" id="nav-tabContent">
     <div className="tab-pane fade show active" id="nav-invoiced" role="tabpanel" aria-labelledby="nav-invoiced-tab">
        {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Invoiced Report
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData}
                columns={columnsInvoiced}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterInvoiced rows={combinedData} />
            </tfoot>
          </table>
            </div>
          </div>
        )}

          </div>
      <div className="tab-pane" id="nav-collected" role="tabpanel" aria-labelledby="nav-collected-tab">
        {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Collection Report
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData.filter(payment => (payment.paid > 0 || payment.lab_paid > 0 || payment.inv_paid > 0 || payment.min_paid > 0))}
                columns={columnsCollect}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterCollect rows={combinedData.filter(payment => (payment.paid > 0 || payment.lab_paid > 0 || payment.inv_paid > 0 || payment.min_paid > 0))} />
            </tfoot>
          </table>
            </div>
          </div>
        )}

          </div>
          <div className="tab-pane" id="nav-refund" role="tabpanel" aria-labelledby="nav-refund-tab">
              <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                Refund Report
               </h3>
               {!isLoading && refundData.length > 0 ? (
                <div style={{ height: "100%", width: "100%" }} className="mt-4">
                  <DataGrid className="mt-4"
                    sx={{
                      boxShadow: 4,
                      border: 4,
                      borderColor: 'primary.light',
                      '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                      },
                    }}
                    rows={rows1}
                    columns={columns1}
                    pageSize={10}
                    slots={{
                      toolbar: GridToolbar,
                      footer1: () => <Footer1 rows={rows1} />,
                    }}
                    autoHeight
                  />
                </div>
              ) : (
                <></>
              )}
          </div>
          <div className="tab-pane" id="nav-due" role="tabpanel" aria-labelledby="nav-due-tab">
              <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                Paid Dues
              </h3>
              {!isLoading && dueData.length > 0 ? (
                <div style={{ height: "100%", width: "100%" }} className="mt-4">
                  <DataGrid className="mt-4"
                    sx={{
                      boxShadow: 4,
                      border: 4,
                      borderColor: 'primary.light',
                      '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                      },
                    }}
                    rows={rows2}
                    columns={columns2}
                    pageSize={10}
                    slots={{
                      toolbar: GridToolbar,

                    }}

                    autoHeight
                  />
                  <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tfoot>
                  <Footer2 rows={rows2} />
                </tfoot>
              </table>
                </div>
              ) : (
                <></>
              )}
          </div>
          <div className="tab-pane" id="nav-discount" role="tabpanel" aria-labelledby="nav-discount-tab">
                    {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Discount
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData.filter(payment => (payment.disc > 0 || payment.lab_disc > 0 || payment.inv_disc > 0 || payment.min_disc > 0))}
                columns={columnsCollect}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterCollect rows={combinedData.filter(payment => (payment.disc > 0 || payment.lab_disc > 0 || payment.inv_disc > 0 || payment.min_disc > 0))} />
            </tfoot>
          </table>
            </div>
          </div>
        )}

          </div>
          <div className="tab-pane" id="nav-pending" role="tabpanel" aria-labelledby="nav-pending-tab">
        {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Pending Dues
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData.filter(payment => (payment.balance > 0 || payment.lab_balance > 0 || payment.inv_balance > 0 || payment.min_balance > 0))}
                columns={columnsDue}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tfoot>
                  <FooterDue rows={combinedData.filter(payment => (payment.balance > 0 || payment.lab_balance > 0 || payment.inv_balance > 0 || payment.min_balance > 0))} />
                </tfoot>
              </table>
            </div>
          </div>
        )}
          </div>

        </div>
        </div>

    </section>
  );
}

export default PaymentDetail;
